// extracted by mini-css-extract-plugin
export var centerText = "_dt-8";
export var container = "_dt-0";
export var doughnutContainer = "_dt-7";
export var legend = "_dt-a";
export var legendItemColorDisplay = "_dt-b";
export var legendItemLabel = "_dt-d";
export var legendItemValue = "_dt-c";
export var lg = "_dt-5";
export var maxWidth = "_dt-9";
export var md = "_dt-4";
export var responsive = "_dt-6";
export var sm = "_dt-3";
export var xs = "_dt-2";
export var xxs = "_dt-1";